/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_NorwegianInputs */

const en_speechmatics_target_language_norwegian = /** @type {(inputs: Speechmatics_Target_Language_NorwegianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norwegian`)
};

const fr_speechmatics_target_language_norwegian = /** @type {(inputs: Speechmatics_Target_Language_NorwegianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norvegien`)
};

const de_speechmatics_target_language_norwegian = /** @type {(inputs: Speechmatics_Target_Language_NorwegianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`norwegisch`)
};

const it_speechmatics_target_language_norwegian = /** @type {(inputs: Speechmatics_Target_Language_NorwegianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`norvegese`)
};

const ru_speechmatics_target_language_norwegian = /** @type {(inputs: Speechmatics_Target_Language_NorwegianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`норвежский`)
};

const es_speechmatics_target_language_norwegian = /** @type {(inputs: Speechmatics_Target_Language_NorwegianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`noruego`)
};

const zh_cn2_speechmatics_target_language_norwegian = /** @type {(inputs: Speechmatics_Target_Language_NorwegianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`挪威`)
};

const ja_speechmatics_target_language_norwegian = /** @type {(inputs: Speechmatics_Target_Language_NorwegianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ノルウェー語`)
};

const hi_speechmatics_target_language_norwegian = /** @type {(inputs: Speechmatics_Target_Language_NorwegianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नार्वेजियन`)
};

const pt_pt2_speechmatics_target_language_norwegian = /** @type {(inputs: Speechmatics_Target_Language_NorwegianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`norueguês`)
};

/**
* | output |
* | --- |
* | "Norwegian" |
*
* @param {Speechmatics_Target_Language_NorwegianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_norwegian = /** @type {((inputs?: Speechmatics_Target_Language_NorwegianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_NorwegianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_norwegian(inputs)
	if (locale === "de") return de_speechmatics_target_language_norwegian(inputs)
	if (locale === "it") return it_speechmatics_target_language_norwegian(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_norwegian(inputs)
	if (locale === "es") return es_speechmatics_target_language_norwegian(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_norwegian(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_norwegian(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_norwegian(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_norwegian(inputs)
	return en_speechmatics_target_language_norwegian(inputs)
});